/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-undef */
/* eslint-disable no-bitwise */
import { SvgIcon, Tooltip, tooltipClasses } from "@mui/material";
import KeyboardArrowUpOutlinedIcon from "@mui/icons-material/KeyboardArrowUpOutlined";
import { makeStyles, styled } from "@mui/styles";
import React from "react";
import { DateTime } from "luxon";
import AuditIcon from "./assets/AuditIcon.svg";
import { formatDateWithOtherDetails } from "./utils";

const useStyles = makeStyles({
  historyContainer: {
    width: "100%"
  },
  historyContainerFirst: {
    width: "100%",
    marginTop: "-7%"
  },
  stepperContainer: {
    marginLeft: "-20px",
    padding: "8px",
    flexDirection: "column-reverse",
    display: "flex"
  },
  verticalLine: {
    borderLeft: "solid 2px #969696",
    marginLeft: "20px",
    paddingBottom: "10%",
    paddingTop: "5%"
  },
  verticalLineFirst: {
    borderLeft: "solid 2px #969696",
    marginLeft: "20px",
    paddingBottom: "10%"
  },
  verticalLineLast: {
    borderLeft: "solid 2px #969696",
    marginLeft: "20px"
  },
  bullet: {
    height: "10px",
    width: "10px",
    marginLeft: "-6px",
    backgroundColor: "#969696",
    borderRadius: "50%",
    display: "inline-block"
  },
  bulletBlue: {
    height: "10px",
    width: "10px",
    marginLeft: "-6px",
    backgroundColor: "#0625A8",
    borderRadius: "50%",
    display: "inline-block",
    marginTop: "16px"
  },
  historyLabelContainer: {
    width: "auto",
    marginLeft: "15px",
    marginTop: "-20px",
    fontSize: "16px",
    fontWeight: 500,
    color: "#000000",
    minWidth: "175px"
  },
  historyLabelContainerBlue: {
    width: "auto",
    marginLeft: "15px",
    marginTop: "-20px",
    fontSize: "16px",
    fontWeight: 600,
    color: "#0625A8",
    minWidth: "175px"
  },
  nameAndTimeContainer: {
    marginLeft: "6%",
    display: "flex",
    flexFlow: "row",
    marginTop: "2px",
    whiteSpace: "nowrap"
  },
  nameAndTime: {
    fontSize: "12px",
    lineHeight: "1.64",
    color: "#3c3c3c",
    marginTop: 0
  },
  nameAndTimeBlue: {
    fontSize: "12px",
    lineHeight: "1.64",
    color: "#0625A8",
    marginTop: 0
  },
  blueDot: {
    display: "inline-block",
    width: "7px",
    height: "7px",
    borderRadius: "50%",
    backgroundColor: "#0259cc",
    margin: "6px 71px 1px 6px"
  }
});

export const TooltipContent = (props) => {
  const classes = useStyles();
  const { steps, type } = props;
  if (steps?.length > 3) {
    steps.splice(3);
  }

  return (
    <div className={classes.stepperContainer}>
      {steps
        ?.slice()
        .reverse()
        .map((step, index) => {
          const firstPoint = index === steps.length - 1;
          return (
            <div
              className={
                firstPoint
                  ? classes.historyContainerFirst
                  : classes.historyContainer
              }
            >
              {firstPoint && (
                <KeyboardArrowUpOutlinedIcon
                  sx={{
                    marginX: "10px",
                    marginBottom: "-16px",
                    color: "#969696"
                  }}
                />
              )}
              <div
                className={
                  `${index}` << `${steps.length}`
                    ? `${index}` === `${steps.length}`
                      ? classes.verticalLine
                      : classes.verticalLineFirst
                    : classes.verticalLineLast
                }
              >
                {firstPoint ? (
                  <span className={classes.bulletBlue} />
                ) : (
                  <span className={classes.bullet} />
                )}
                <div
                  className={
                    firstPoint
                      ? classes.historyLabelContainerBlue
                      : classes.historyLabelContainer
                  }
                >
                  {`${
                    typeof step?.value === "string"
                      ? formatDateWithOtherDetails(step?.value, type)
                      : step?.value
                  }`}
                </div>

                <div className={classes.nameAndTimeContainer}>
                  <span
                    className={
                      firstPoint ? classes.nameAndTimeBlue : classes.nameAndTime
                    }
                  >
                    {step.actorName}
                  </span>
                  <span style={{ marginLeft: "2px", marginRight: "2px" }}>
                    |
                  </span>
                  <span
                    className={
                      firstPoint ? classes.nameAndTimeBlue : classes.nameAndTime
                    }
                  >
                    {DateTime.fromMillis(step.timestamp).toFormat(
                      "MM-dd-yyyy HH:mm"
                    )}
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      <div style={{ marginBottom: "10px" }}>
        <SvgIcon style={{ marginLeft: "12px", marginBottom: "-8px" }}>
          <AuditIcon />
        </SvgIcon>
        <span style={{ fontSize: "18px", fontWeight: "600" }}>
          EDIT HISTORY
        </span>
      </div>
    </div>
  );
};

export const HtmlTooltip = styled(({ className, ...props }) => {
  return <Tooltip {...props} classes={{ popper: className }} />;
})(() => {
  return {
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundImage:
        "linear-gradient(1deg, #F8FAFF 2%, #F5F7FE 41%, #F6F8FF 100%)",
      border: "1px solid #D5D5D5",
      boxShadow: "0 2px 8px 0 rgba(0,0,0,0.12)",
      backgroundColor: "#FFFFFF",
      color: "rgba(0, 0, 0, 0.87)",
      fontSize: "14",
      overflow: "auto"
      // border: "1px solid #dadde9"
    }
  };
});
